<template>
    <div class="text-center py-2">
        <b-form-file class="d-none" :accept="acceptedFiles" :name="paramName" ref="fileInput" v-model="file" @input="fileChanged"/>
        <input type="submit" v-if="file" class="btn btn-primary btn-sm px-3 btn-rounded" value="SUBMIT NEW ASSET"/>
        <div v-else @click="selectFile" class="btn btn-outline btn-sm btn-rounded px-3">
            CHANGE ASSET
        </div>
    </div>
</template>

<script>
  export default {
    props: ['paramName', 'targetImg', 'targetStatus', 'assetType'],

    data: function () {
      return {
        file: null,
      }
    },

    computed: {
      isVideo() {
        return this.assetType && this.assetType.toLowerCase() === "video"
      },

      acceptedFiles() {
        if (this.isVideo) {
          return "video/mp4"
        } else {
          return "image/jpeg"
        }
      }
    },

    methods: {
      fileChanged: function(file) {
        if (this.isVideo) {
          const video = $(`${this.targetImg} video`)[0]

          if (video) {
            video.src = URL.createObjectURL(file)
            video.load()
          }

        } else {
          $(`${this.targetImg} .img-bg`).css('background-image', `url(${URL.createObjectURL(file)})`)
        }

        $(this.targetStatus).hide()
      },

      selectFile: function () {
        this.$refs.fileInput.$el.childNodes[0].click()
      }
    }
  }
</script>